import { UseCase } from "../../useCase"
import { UpdateSurveyCompletionRequest } from "./request"
import { UpdateSurveyCompletionResponse } from "./response"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class UpdateSurveyCompletionUseCase
	implements UseCase<UpdateSurveyCompletionRequest, UpdateSurveyCompletionResponse>
{
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(request: UpdateSurveyCompletionRequest): Promise<UpdateSurveyCompletionResponse> {
		return this._repository.updateSurveyCompletion(request)
	}
}
